module.exports = __webpack_public_path__ + "img/pin.0501eea9.svg";